export default __webpack_public_path__ + "static/media/undraw-date.0d3713c0.svg";